// Constants.
import * as ErrorConstants from 'constants/ErrorConstants';
import * as AuthConstants from 'constants/AuthConstants';

const initialState = {
  errorStatus: '',
  errorMessage: '',
};

export default function error(state = initialState, action = {}) {
  switch (action.type) {
    case ErrorConstants.LOAD_REQUEST_FAILURE: {
      let message = '';
      if (action.response && action.response.data && action.response.data.error) {
        message = action.response.data.error;
      }
      else if (action.response && action.response.data && action.response.data.detail) {
        message = action.response.data.detail;
      }
      else if (action.response && action.response.statusText) {
        message = action.response.data.detail;
      }
      return {
        ...state,
        errorStatus: action.response && action.response.status,
        errorMessage: message,
      };
    }
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        errorStatus: '',
        errorMessage: '',
      };
    default:
      return state;
  }
}
